<!-- the-story -->
<template>
  <div>
    <div class="wrapper">
      <h2 class="title">THE STORY</h2>
      <div class="story">
        <p>This is the year 2xxx. On another planet the metaverse parallel to human society a mysterious killer organization has appeared. </p>
        <p>It often flashes in prosperous places killing innocent people and causing devastating damage. People were terrified and fled the metaverse.</p>
        <p>It quickly aroused the vigilance of various platforms.</p>
        <p>In order to maintain the safety of the Metaverse they joined forces and issued a reward for the capture of the Killer</p>
        <p>The wanted order was issued and all the platforms on the Metaverse became their own camps and the prelude to the battle to defend the Metaverse began.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>
<style lang='scss' rel='stylesheet/scss' scoped>
@import '../style/common.scss';
@import '../style/media.scss';
.story{
  width:50%;
  font-size: 20px;
  font-weight: bolder;
  padding:20px;
  border-radius: 20px;
  box-sizing: border-box;
  transition: all .3s;
  &:hover{
    background-color: black;
    color: #fff;
    z-index: 9999;
    transform:scale(1.2);
  }
}
</style>